import { Feedback, Job, Variation } from '../types';
import apiRequest from './apiRequest';

type Response = {
  animationNumber: number;
  comment: string;
  createdAt: string;
  jobID: string;
  sentiment: 'positive' | 'negative';
  userID: string;
  PK: string;
  SK: string;
};

export default async function postFeedback({
  jobID,
  animationNumber,
  sentiment,
  comment,
}: Feedback) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/jobs/${jobID}/feedback?animationNumber=${animationNumber}`,
    {
      method: 'POST',
      body: JSON.stringify({
        comment,
        sentiment,
      }),
    },
  );
}
